/**
 * Base renderer.
 * @memberOf woosmap.layers.renderers
 */
class BaseRenderer {
    /**
     * @param {RendererOptions} options
     * @param {Object} options
     * @constructor
     */
    constructor(options) {
        this._options = options || {};

        const _styler = this._options.styler;
        if (!_styler) throw new Error("Styler option is mandatory.");

        this.styler = _styler;

        this._selectedStore = undefined;

        this._listeners = {};

        if (this._options.click) {
            this.addEventListener("click", this._options.click);
        }

        if (this._options.eventListeners) {
            const eventListeners = this._options.eventListeners;
            for (const eventListenerKey in eventListeners) {
                if (eventListeners.hasOwnProperty(eventListenerKey)) {
                    this.addEventListener(eventListenerKey, eventListeners[eventListenerKey]);
                }
            }
        }

        this._storeEventManager = null;
    }

    /**
     * Should be moved into defaultRenderer
     * @private
     */
    _registerStoreEventTriggers() {
        const _registerEvent = (eventName) => {
            this._addGoogleEventListener(eventName, (store) => {
                this._storeEventManager.triggerWithSource(this, eventName, store);
            });
        };

        const supportedEvents = this._storeEventManager.supportedEvents();
        for (const eventKey in supportedEvents) {
            if (supportedEvents.hasOwnProperty(eventKey)) {
                const eventName = supportedEvents[eventKey];
                _registerEvent.apply(this, [eventName]);
            }
        }
    }

    /**
     * @private
     */
    _registerEventListeners() {
        for (const eventName in this._listeners) {
            if (this._listeners.hasOwnProperty(eventName)) {
                this._storeEventManager.addListenerForSource(this, eventName, this._listeners[eventName]);
            }
        }
    }

    /**
     *
     * @param {String} event
     * @param {StoreEventCallback} listener
     * @private
     */
    _addGoogleEventListener(event, listener) {}

    setStoreEventManager(storeEventManager) {
        if (storeEventManager) {
            this._storeEventManager = storeEventManager;

            this._registerStoreEventTriggers();

            this._registerEventListeners();
        }
    }

    /**
     * Adds an eventListener triggered when the event is triggered on markers.
     * @param {EventName} event
     * @param {StoreEventListener} listener
     */
    addEventListener(event, listener) {
        if (this._storeEventManager) {
            this._storeEventManager.addListenerForSource(this, event, listener);
        } else {
            this._listeners[event] = listener;
        }
    }

    removeEventListener(event) {
        if (this._storeEventManager) {
            this._storeEventManager.clearListenersWithSource(this, event);
        } else {
            delete this._listeners[event];
        }
    }

    /**
     * Build the click listener with the callback argument
     * @param {StoreEventListener} callback
     * @deprecated
     */
    setClick(callback) {
        this.addEventListener("click", callback);
    }

    /**
     * Getter to access to the map instance
     * @returns {google.maps.Map}
     */
    getMap() {}

    /**
     * Set the map instance
     * @param {google.maps.Map} map
     */
    setMap(map) {}

    /**
     * Call to display the stores with the basic style
     * @param {GeoJSON} stores
     */
    displayStores(stores) {}

    /**
     * Call to display the stores with the numbered style
     * @param {GeoJSON} stores
     */
    displayNumberedStores(stores) {}

    /**
     * Call on each tiles request.
     * @param {GeoJSON} data
     */
    tileDidLoad(data) {
        this.displayStores(data);
    }

    /**
     * Called once all tiles request are finished.
     */
    tilesDidLoad() {}

    /**
     * Use the `selected` style for the `selectedStore`
     * @param {Store} selectedStore the store to select.
     */
    selectStore(selectedStore) {}

    /**
     * Removes all the data and style from the layer.
     */
    clear() {}
}

module.exports = BaseRenderer;
